/* eslint-disable implicit-arrow-linebreak */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createHoldingServiceRequest } from '../../service';

type UseHoldingRequestOpts = {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
};

function useHoldingRequestMutation(propertyId: number, opts: UseHoldingRequestOpts = {}) {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: (data: {
            services: number[];
            holdDate: number;
            reasonNote: string;
        }) =>
            createHoldingServiceRequest(
                propertyId,
                data.services,
                data.holdDate,
                data.reasonNote
            ),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['property', propertyId],
            });

            if (opts.onSuccess !== undefined) {
                opts.onSuccess();
            }
        },
        onError: (error) => {
            if (opts.onError !== undefined) {
                opts.onError(error);
            }
        },
    });

    return query;
}

export { useHoldingRequestMutation };
